import * as angular from 'angular';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { EmailFailureDialogService, ShareDialogService, ShareDialogComponent } from '@mode/reports/ui';

export const DowngradedReportsUIModule = angular
  .module('downgraded-reports-ui', [])
  .service('EmailFailureDialogService', downgradeInjectable(EmailFailureDialogService))
  .service('ShareDialogService', downgradeInjectable(ShareDialogService))
  .directive('modeShareDialog', downgradeComponent({ component: ShareDialogComponent })).name;
